import { createAction } from 'redux-actions';
export const setForeignCardAction = createAction('SET_FOREIGN_CARD_ACTION');
